import {
  $convertFromMarkdownString,
  $convertToMarkdownString,
  TRANSFORMERS,
  type TextFormatTransformer,
  type Transformer,
} from "@lexical/markdown";

const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const UNDERLINE_PLACEHOLDER = "\u0001U\u0001";
const UNDERLINE_TRANSFORMER: TextFormatTransformer = { format: ["underline"], tag: UNDERLINE_PLACEHOLDER, type: "text-format" };
const MARKDOWN_TRANSFORMERS: Array<Transformer> = [UNDERLINE_TRANSFORMER, ...TRANSFORMERS];
const UNDERLINE_PAIR = new RegExp(`${escapeRegExp(UNDERLINE_PLACEHOLDER)}(.*?)${escapeRegExp(UNDERLINE_PLACEHOLDER)}`, "gs");

const normalizeSerializedMarkdown = (markdown: string): string => {
  return markdown.replace(UNDERLINE_PAIR, "<ins>$1</ins>").replace(/~~(.*?)~~/gs, "<del>$1</del>");
};

const normalizeIncomingMarkdown = (markdown: string): string => {
  return markdown
    .replace(/<ins>(.*?)<\/ins>/gs, `${UNDERLINE_PLACEHOLDER}$1${UNDERLINE_PLACEHOLDER}`)
    .replace(/<del>(.*?)<\/del>/gs, "~~$1~~");
};

export const serializeMarkdown = (): string => normalizeSerializedMarkdown($convertToMarkdownString(MARKDOWN_TRANSFORMERS));

export const hydrateMarkdown = (markdown: string): void => {
  $convertFromMarkdownString(normalizeIncomingMarkdown(markdown), MARKDOWN_TRANSFORMERS);
};
